function createDemoLogo() {
  const svg = `
        <svg xmlns="http://www.w3.org/2000/svg" width="220" height="120" viewBox="0 0 220 120">
            <defs>
                <linearGradient id="demoLogoBg" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stop-color="#1a4f9f" />
                    <stop offset="100%" stop-color="#0bd3ff" />
                </linearGradient>
            </defs>
            <rect width="220" height="120" rx="12" fill="url(#demoLogoBg)" />
            <text x="110" y="52" text-anchor="middle" font-size="22" font-weight="700" fill="#ffffff">DEMO</text>
            <text x="110" y="82" text-anchor="middle" font-size="18" fill="#e9f7ff">业绩演示</text>
        </svg>
    `;
  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
}

function getDemoSpreadData() {
  return [
    {
      CityName: "北京",
      CityCaption: "北京市",
      lng: 116.4074,
      lat: 39.9042,
      count: 32,
    },
    {
      CityName: "上海",
      CityCaption: "上海市",
      lng: 121.4737,
      lat: 31.2304,
      count: 28,
    },
    {
      CityName: "广州",
      CityCaption: "广州市",
      lng: 113.2644,
      lat: 23.1291,
      count: 24,
    },
    {
      CityName: "深圳",
      CityCaption: "深圳市",
      lng: 114.0579,
      lat: 22.5431,
      count: 26,
    },
    {
      CityName: "杭州",
      CityCaption: "杭州市",
      lng: 120.1551,
      lat: 30.2741,
      count: 18,
    },
    {
      CityName: "成都",
      CityCaption: "成都市",
      lng: 104.0668,
      lat: 30.5728,
      count: 17,
    },
    {
      CityName: "武汉",
      CityCaption: "武汉市",
      lng: 114.3055,
      lat: 30.5931,
      count: 14,
    },
    {
      CityName: "西安",
      CityCaption: "西安市",
      lng: 108.9398,
      lat: 34.3416,
      count: 11,
    },
    {
      CityName: "苏州",
      CityCaption: "苏州市",
      lng: 120.5853,
      lat: 31.2989,
      count: 13,
    },
    {
      CityName: "南京",
      CityCaption: "南京市",
      lng: 118.7969,
      lat: 32.0603,
      count: 12,
    },
    {
      CityName: "重庆",
      CityCaption: "重庆市",
      lng: 106.5516,
      lat: 29.563,
      count: 16,
    },
    {
      CityName: "天津",
      CityCaption: "天津市",
      lng: 117.2009,
      lat: 39.0842,
      count: 10,
    },
    {
      CityName: "郑州",
      CityCaption: "郑州市",
      lng: 113.6254,
      lat: 34.7466,
      count: 11,
    },
    {
      CityName: "长沙",
      CityCaption: "长沙市",
      lng: 112.9388,
      lat: 28.2282,
      count: 10,
    },
    {
      CityName: "青岛",
      CityCaption: "青岛市",
      lng: 120.3826,
      lat: 36.0671,
      count: 9,
    },
    {
      CityName: "合肥",
      CityCaption: "合肥市",
      lng: 117.2272,
      lat: 31.8206,
      count: 8,
    },
    {
      CityName: "厦门",
      CityCaption: "厦门市",
      lng: 118.0894,
      lat: 24.4798,
      count: 7,
    },
    {
      CityName: "福州",
      CityCaption: "福州市",
      lng: 119.2965,
      lat: 26.0745,
      count: 7,
    },
    {
      CityName: "宁波",
      CityCaption: "宁波市",
      lng: 121.5503,
      lat: 29.8746,
      count: 8,
    },
    {
      CityName: "无锡",
      CityCaption: "无锡市",
      lng: 120.3119,
      lat: 31.4912,
      count: 7,
    },
    {
      CityName: "昆明",
      CityCaption: "昆明市",
      lng: 102.8329,
      lat: 24.8801,
      count: 6,
    },
    {
      CityName: "沈阳",
      CityCaption: "沈阳市",
      lng: 123.4315,
      lat: 41.8057,
      count: 6,
    },
    {
      CityName: "大连",
      CityCaption: "大连市",
      lng: 121.6147,
      lat: 38.914,
      count: 5,
    },
    {
      CityName: "南昌",
      CityCaption: "南昌市",
      lng: 115.8582,
      lat: 28.6829,
      count: 6,
    },
    {
      CityName: "贵阳",
      CityCaption: "贵阳市",
      lng: 106.6302,
      lat: 26.647,
      count: 5,
    },
    {
      CityName: "南宁",
      CityCaption: "南宁市",
      lng: 108.3669,
      lat: 22.817,
      count: 5,
    },
    {
      CityName: "海口",
      CityCaption: "海口市",
      lng: 110.1999,
      lat: 20.044,
      count: 4,
    },
    {
      CityName: "兰州",
      CityCaption: "兰州市",
      lng: 103.8343,
      lat: 36.0611,
      count: 4,
    },
    {
      CityName: "乌鲁木齐",
      CityCaption: "乌鲁木齐市",
      lng: 87.6168,
      lat: 43.8256,
      count: 3,
    },
  ];
}

export function buildReportDemoData(year, baseYear) {
  const currentBaseYear = Number(baseYear) || new Date().getFullYear();
  const currentYear = Number(year) || currentBaseYear;
  const yearGap = currentBaseYear - currentYear;
  const projectCount = Math.max(88, 186 - yearGap * 16);
  const bidAmount = Math.max(62.8, 128.5 - yearGap * 10.6);
  const partnerBuildList = [
    { sCompany: "保利发展", TotalBuildArea_: 96.8, TotalBuildArea: "96.8" },
    { sCompany: "华润置地", TotalBuildArea_: 88.4, TotalBuildArea: "88.4" },
    { sCompany: "招商蛇口", TotalBuildArea_: 79.6, TotalBuildArea: "79.6" },
    { sCompany: "龙湖集团", TotalBuildArea_: 68.2, TotalBuildArea: "68.2" },
    { sCompany: "建发房产", TotalBuildArea_: 61.5, TotalBuildArea: "61.5" },
    { sCompany: "越秀地产", TotalBuildArea_: 54.7, TotalBuildArea: "54.7" },
    { sCompany: "绿城中国", TotalBuildArea_: 49.3, TotalBuildArea: "49.3" },
    { sCompany: "金地集团", TotalBuildArea_: 43.8, TotalBuildArea: "43.8" },
    { sCompany: "保利发展", TotalBuildArea_: 96.8, TotalBuildArea: "96.8" },
    { sCompany: "华润置地", TotalBuildArea_: 88.4, TotalBuildArea: "88.4" },
    { sCompany: "招商蛇口", TotalBuildArea_: 79.6, TotalBuildArea: "79.6" },
    { sCompany: "龙湖集团", TotalBuildArea_: 68.2, TotalBuildArea: "68.2" },
    { sCompany: "建发房产", TotalBuildArea_: 61.5, TotalBuildArea: "61.5" },
    { sCompany: "越秀地产", TotalBuildArea_: 54.7, TotalBuildArea: "54.7" },
    { sCompany: "绿城中国", TotalBuildArea_: 49.3, TotalBuildArea: "49.3" },
    { sCompany: "金地集团", TotalBuildArea_: 43.8, TotalBuildArea: "43.8" },
    { sCompany: "龙湖集团", TotalBuildArea_: 68.2, TotalBuildArea: "68.2" },
    { sCompany: "建发房产", TotalBuildArea_: 61.5, TotalBuildArea: "61.5" },
    { sCompany: "越秀地产", TotalBuildArea_: 54.7, TotalBuildArea: "54.7" },
    { sCompany: "绿城中国", TotalBuildArea_: 49.3, TotalBuildArea: "49.3" },
    { sCompany: "金地集团", TotalBuildArea_: 43.8, TotalBuildArea: "43.8" },
  ];
  const partnerProjectList = [
    {
      companyName: "华润置地",
      iThisCoverCnt: 18,
      iRange: "12.8%",
      iRangeType: 1,
    },
    {
      companyName: "保利发展",
      iThisCoverCnt: 16,
      iRange: "10.5%",
      iRangeType: 1,
    },
    {
      companyName: "招商蛇口",
      iThisCoverCnt: 14,
      iRange: "8.6%",
      iRangeType: 1,
    },
    {
      companyName: "龙湖集团",
      iThisCoverCnt: 11,
      iRange: "5.1%",
      iRangeType: 1,
    },
    {
      companyName: "建发房产",
      iThisCoverCnt: 10,
      iRange: "4.2%",
      iRangeType: 1,
    },
    {
      companyName: "越秀地产",
      iThisCoverCnt: 9,
      iRange: "3.7%",
      iRangeType: 1,
    },
    {
      companyName: "绿城中国",
      iThisCoverCnt: 8,
      iRange: "2.9%",
      iRangeType: 1,
    },
    {
      companyName: "金地集团",
      iThisCoverCnt: 7,
      iRange: "2.2%",
      iRangeType: 1,
    },
    {
      companyName: "中海地产",
      iThisCoverCnt: 6,
      iRange: "1.8%",
      iRangeType: 1,
    },
    {
      companyName: "滨江集团",
      iThisCoverCnt: 5,
      iRange: "1.2%",
      iRangeType: 1,
    },
  ];
  const monthList = [
    "1月",
    "2月",
    "3月",
    "4月",
    "5月",
    "6月",
    "7月",
    "8月",
    "9月",
    "10月",
    "11月",
    "12月",
  ];
  const countMoneyChart = monthList.map((month, index) => {
    const baseCount = [9, 11, 13, 15, 17, 18, 16, 19, 21, 18, 15, 14][index];
    const baseAmount = [
      6.5, 7.8, 8.6, 9.4, 10.1, 11.5, 10.8, 12.3, 13.6, 11.8, 9.6, 8.9,
    ][index];
    return {
      sCateDesc: month,
      iCnt: Math.max(4, baseCount - yearGap),
      BidAmount: Number(Math.max(3.2, baseAmount - yearGap * 0.7).toFixed(1)),
    };
  });
  const companyHomeSpreadData = getDemoSpreadData().map((item) => {
    return {
      ...item,
      count: Math.max(6, item.count - yearGap * 2),
    };
  });
  const partnerNewList = [
    {
      StrokeNewsId: 90001,
      title: "与保利发展联合中标华东重点住宅项目",
      content:
        "围绕精装交付、标准化供应与交付协同展开深度合作，已进入批量落地阶段。",
      companyName: "保利发展",
      date: `${currentYear}-03-18`,
    },
    {
      StrokeNewsId: 90002,
      title: "华润置地项目实现样板段快速交付",
      content: "通过联合投标与产品前置策略，缩短交付周期，提升项目履约效率。",
      companyName: "华润置地",
      date: `${currentYear}-04-09`,
    },
    {
      StrokeNewsId: 90003,
      title: "招商蛇口西南区域项目完成年度签约",
      content: "项目覆盖住宅与商业综合体，合作范围延伸到多个核心城市。",
      companyName: "招商蛇口",
      date: `${currentYear}-06-21`,
    },
    {
      StrokeNewsId: 90004,
      title: "龙湖集团新项目进入联合推进期",
      content: "聚焦高端改善产品线，围绕产品力与客户交付体验进行深度协同。",
      companyName: "龙湖集团",
      date: `${currentYear}-09-12`,
    },
  ];

  return {
    logo: createDemoLogo(),
    partnerBuildData: {
      Header: "万㎡",
      AllArea: partnerBuildList.reduce(
        (sum, item) => sum + Number(item.TotalBuildArea_),
        0,
      ),
      aList: partnerBuildList,
    },
    partnerProjectData: {
      aList: partnerProjectList,
    },
    companyHomeSpreadData,
    companyPartnerCoverData: {
      iTotal: 36 - yearGap * 2,
      iRate: 0.68 - yearGap * 0.04,
    },
    countMoneyHead: {
      sProjectHeader: "个",
      iCounts: projectCount,
      sProjectRate: `${(18.6 - yearGap * 2.1).toFixed(1)}%`,
      iCountType: "1",
      sBidHeader: "亿元",
      BidAmount: bidAmount.toFixed(1),
      sBidRate: `${(12.4 - yearGap * 1.7).toFixed(1)}%`,
      iAmountType: "1",
    },
    countMoneyChart,
    partnerNewList,
    partnerNewListCount: partnerNewList.length,
    maxProjectValue: partnerProjectList[0].iThisCoverCnt,
  };
}
